import { useProgressReportStore } from '@entities/progress-report'
import { useProgressReportApi } from '@entities/progress-report'
import { onDisciplineReady } from '@entities/customer'
import { show404 } from '@shared/lib/page-error'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const progressReportStore = useProgressReportStore()

  const progressReportId: string | null = to?.params?.report as string || null
  onDisciplineReady((discipline) => {
    const isSameReportReady = progressReportStore.getReportStatus(discipline.id) === 'ready'
      && String(progressReportStore.getReportById(discipline.id)?.id) === progressReportId

    void useProgressReportApi({
      disciplineId: discipline.id,
      progressReportId,
      mode: isSameReportReady ? 'refresh' : 'enter',
    }, {
      onError: () => {
        return show404()
      },
    })
  }, { hook: 'NONE' })
})
